import { render, staticRenderFns } from "./BillSettlement.vue?vue&type=template&id=679b2888&"
import script from "./BillSettlement.vue?vue&type=script&lang=js&"
export * from "./BillSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports